import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../components/componentsGeneral/AnimatedView/AnimatedView';
import ShipmentEntryContainer from '../../../components/componentsControlTower/ShipmentEntry/ShipmentEntryContainer';

class ctrlTwrShipmentEntryView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <ShipmentEntryContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection} organizationSelection={this.props.organizationSelection}/>
            </AnimatedView>

        );
    }
}

export default ctrlTwrShipmentEntryView;
